module.exports = __webpack_public_path__ + "static/media/google-mic.e7577d12.svg";